import Chapters from "../../../../api/biblia/chapters";
import FontControllers from "../../../../components/font-controllers";
import Loader from "../../../../components/loader";
import Swiper from "../../../../components/swiper";

export default class Chapter
{
	constructor(biblia) {
		this.biblia = biblia;
		this.handleNextChapter();
		this.handlePreviusChapter();
		this.fontControllers();
		this.handleChapterPicker();
	}

	setChapter(book, chapter = 1) {
		const content = document.querySelector('#biblia-online #content-display');
		content.className = 'chapter-content';

		const api = new Chapters;
		const loader = new Loader(content);

		loader.setLoader();

		this.biblia.advancedSearch.deativeSearchResult();

		api.getChapter(book.slug, chapter)
			.then((data) => {
				loader.unsetLoader();

				if (data) {
					const body = data.body;
					this.createVerses(body, content);
					this.setChapterControllers(body[0].chapter, book.chapter_count);
					this.setChapterTitle(book.chapter);

					book.index = chapter;
					this.setContentBook(book);

					const chapterElemente = document.querySelector(`span[data-chapter="${chapter}"][data-book="${book.slug}"]`);
					this.biblia.books.selectChapter(chapterElemente)
					this.setChapterPiker(book, chapter);
					this.handleSwipeChapter();

				} else {
					this.createVerses(false, content);
				}
			}
		);
	}

	setCapterLoader() {
		const content = document.querySelector('#biblia-online #content-display');
		content.innerText = '';

		const loader = document.createElement('div');
		loader.classList.add('loader');

		content.appendChild(loader)
	}

	setContentBook(book) {
		const contentBook = document.querySelector('#biblia-online #selected-book');

		contentBook.value = JSON.stringify(book);
	}

	setChapterControllers(chapterNumber) {
		const container = document.querySelector('#biblia-online #position-controllers > .position-controllers');
		container.classList.remove('search-page-controllers');
		container.classList.add('chapter-page-controllers');

		const currentTitle = document.querySelector('#biblia-online #position-description');
		currentTitle.innerText = 'CAPÍTULO';

		const number = document.querySelector('#biblia-online #position-number');
		const next = parseInt(chapterNumber) + 1;
		number.setAttribute('data-context', 'chapter');
		number.innerText = chapterNumber;

		const previusButton = document.querySelector('#biblia-online #previus-position');
		previusButton.setAttribute('data-position', chapterNumber - 1);

		const nextButton = document.querySelector('#biblia-online #next-position');
		nextButton.setAttribute('data-position', next);
	}

	setChapterTitle(title) {
		const book = document.querySelector('#biblia-online #content-title');
		book.innerText = title;
	}

	createVerses(verses, chapter) {
		chapter.innerHTML = '';

		if (verses) {
			const result = document.createElement('div');
			result.classList.add('chapter-result');

			verses.forEach(verse => {
				const div = document.createElement('div');
				div.classList.add('verse');

				const number = document.createElement('span');
				number.classList.add('verse-number');
				number.innerText = verse.number;
				div.appendChild(number);

				const content = document.createElement('div');
				content.classList.add('verse-content');
				div.appendChild(content);

				const text = document.createElement('span');
				text.innerText = verse.text;
				content.appendChild(text);

				result.appendChild(div);
			});

			chapter.appendChild(result);
		} else {
			const text = document.createElement('span');
			text.innerText = 'Nenhum resultado encontrado.';

			chapter.appendChild(text);
		}
	}

	handleNextChapter() {
		const nextButton = document.querySelector('#biblia-online #next-position');

		nextButton.addEventListener('click', () => {
			this.getNextChapter();
		});
	}

	getNextChapter() {
		const nextButton = document.querySelector('#biblia-online #next-position');

		if (this.isChapterController()) {
			const next = parseInt(nextButton.getAttribute('data-position'));

			const book = document.querySelector('#biblia-online #selected-book');
			const data = JSON.parse(book.value);

			if (next > parseInt(data.chapter_count)) {
				this.changeSideBook(data, 'next');
				return;
			}

			this.setChapter(data, next);
		}
	}

	handlePreviusChapter() {
		const previusButton = document.querySelector('#biblia-online #previus-position');

		previusButton.addEventListener('click', () => {
			this.getPreviusChapter();
		});
	}

	getPreviusChapter() {
		const previusButton = document.querySelector('#biblia-online #previus-position');

		if (this.isChapterController()) {
			let previus = previusButton.getAttribute('data-position');
			const book = document.querySelector('#biblia-online #selected-book');
			const data = JSON.parse(book.value);

			if (previus > 0) {
				this.setChapter(data, previus);
				return;
			}

			this.changeSideBook(data, 'previus');
		}
	}


	isChapterController() {
		const current = document.querySelector('#biblia-online #position-number');

		return current.getAttribute('data-context') === 'chapter';
	}

	handleSwipeChapter() {
		const content = document.querySelector('#biblia-online #content-display > .chapter-result');
		new Swiper(
			content,
			this.getPreviusChapter.bind(this),
			this.getNextChapter.bind(this)
		);
	}


	changeSideBook(book, position) {
		const books = document.querySelector('#biblia-online #parresia-biblia-books');
		const data = JSON.parse(books.value);

		if (data) {
			for (const key in data) {
				if (Object.hasOwnProperty.call(data, key)) {
					const item = data[key];

					if (item.slug === book.slug) {
						let sideBook;
						let chapter;

						if (position === 'next') {
							sideBook = data[(parseInt(key) + 1)] || item;
							chapter = sideBook === item ? sideBook.chapter_count : 1;
						} else {
							sideBook = data[key - 1] || item;
							chapter = sideBook === item ? 1 : sideBook.chapter_count;
						}

						this.setChapter(sideBook, chapter);
					}
				}
			}
		}
	}

	fontControllers() {
		const plus = document.querySelector('#biblia-online .font-controllers > .plus');
		const minor = document.querySelector('#biblia-online .font-controllers > .minor');
		const content = document.querySelector('#biblia-online #content-display');

		new FontControllers(content, plus, minor);
	}

	setChapterPiker(book, selectedChapter) {
		const chapters = document.querySelector('#biblia-online #position-controllers > .chapter-picker > .book-chapters');
		const bookTitle = document.querySelector('#biblia-online #position-controllers > .chapter-picker > .book-title > span');

		bookTitle.innerText = book.chapter;
		chapters.innerHTML = '';

		for (let index = 1; index <= book.chapter_count; index++) {
			const chapter = document.createElement('span');
			chapter.classList.add('book-chapter');
			chapter.innerText = index;
			chapter.setAttribute('data-chapter', index);
			chapter.setAttribute('data-book', book.slug);

			if (selectedChapter == index) {
				chapter.classList.add('selected');
			}

			chapter.addEventListener('click', () => {
				chapter.classList.add('selected');

				setTimeout(() => {
					this.toogleChapterPicker();
					this.setChapter(book, index);
				}, 100);
			});

			chapters.appendChild(chapter);
		}
	}

	handleChapterPicker() {
		const chapter = document.querySelector('#biblia-online #position-controllers > .position-controllers > .current-position');

		chapter.addEventListener('click', () => {
			if (chapter.parentElement.classList.contains('chapter-page-controllers')) {
				this.toogleChapterPicker();
			}
		});
	}

	toogleChapterPicker() {
		const chapter = document.querySelector('#biblia-online #position-controllers > .position-controllers > .current-position');
		const picker = document.querySelector('#biblia-online #position-controllers > .chapter-picker');

		picker.classList.toggle('open');
		chapter.classList.toggle('selected')
	}
}
